<template>
	<div class="notData">
		<img class="img" src="../assets/img/tablenull@2x.png" />
		<div class="mes-text">{{text}}</div>
	</div>
</template>

<script>
	export default{
		name:'TableNull',
		props:{
			text:{
				type:String,
				default:'No data'
			}
		},
		data(){
			return{
				
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.notData{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.img{
			width: 20%;
			margin-top: 50px;
		}
		.mes-text{
			position: relative;
			font-size: 14px;
			color: #A2A2A2;
			line-height: 30px;
			margin-top: 5px;
			margin-bottom: 50px;
		}
	}
</style>
